// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--37IPj","title":"a10a3f92e9--title--3-Tqw","text":"a10a3f92e9--text--1vVLW"};